import React, { useCallback, useEffect, useState } from "react";
import EducationSidebar from "features/educationVideo/components/EducationSidebar";
import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";
import SubscriptionPopup from "common/components/SubscriptionPopup";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import "./stylesMobile.scss";

import VideoImg from "assets/images/video-img.png";
import { useTypedDispatch } from "store";
import { getAllVideos, getVideosForCustomer } from "store/users/thunkActions";
import debounce from "lodash.debounce";
import { ICommonResponse, ICourse, IVideo } from "types/common";

const EducationalVideoMobile = () => {
  const dispatch = useTypedDispatch();
  const [allVideos, setAllVideos] = useState<IVideo[]>([]);
  const [allCourses, setAllCourses] = useState<ICourse[]>([]);
  const [currentVideo, setCurrentVideo] = useState<IVideo["Data"] | null>(null);
  const [play, setPlay] = useState(false);
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  const getData = useCallback(
    debounce(async (CourseId: number) => {
      try {
        const res = (await dispatch(getVideosForCustomer(CourseId))) as unknown as ICommonResponse<
          IVideo[]
        >;
        setAllVideos(res?.Results);
        if (res?.Results[0]?.Data) {
          setCurrentVideo(res.Results[0].Data);
        }
      } catch (err) {
        console.error("Failed to fetch mobile videos:", err);
      }
    }, 200),
    [dispatch]
  );

  const handleVideoSelect = (videoData: IVideo["Data"]) => {
    if (videoData.Url) {
      setCurrentVideo(videoData);
      setPlay(true);
    } else {
      setShowSubscriptionPopup(true);
    }
  };

  const getAllVideoCourses = async () => {
    const res = (await dispatch(getAllVideos())) as unknown as ICommonResponse<ICourse[]>;
    setAllCourses(res?.Results);
  };

  useEffect(() => {
    getAllVideoCourses();
  }, []);

  useEffect(() => {
    if (allCourses[0]?.Data?.Id_Course) {
      getData(allCourses[0].Data.Id_Course);
    }
  }, [allCourses, getData]);

  return (
    <div style={{ overflow: "hidden" }} className="educationalVideo-screen-wrapper-mobile">
      <SubscriptionPopup
        show={showSubscriptionPopup}
        onHide={() => setShowSubscriptionPopup(false)}
      />
      <MainPageHeaderMobile />
      <div className="EducationalVideo-wrapper-otr">
        <div className="EducarionalSidebar-main">
          <div className="Educarional-sidebar">
            <div className="heading-sidebar">
              <span>בחר נושא:</span>
            </div>
            <EducationSidebar
              courses={allCourses}
              videos={allVideos}
              onClickCourse={(val: number) => {
                setPlay(false);
                setCurrentVideo(null);
                setTimeout(() => {
                  getData(val);
                }, 500);
              }}
              onClickVideo={handleVideoSelect}
              onCloseVideo={() => setCurrentVideo(null)}
              play={play}
              setPlay={setPlay}
            />
          </div>
        </div>
        <div className="EducationalVideo-wrapper-inr">
          <h2 className="heading">{currentVideo?.Title}</h2>
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <div className="video-videoSidebar">
              <div className="video-heading-otr">
                {/* <div className="video-otr">
                  {currentVideo?.Url && (
                    <Video
                      key={currentVideo?.Url}
                      type={currentVideo?.VideoType}
                      source={currentVideo?.Url}
                      play={play}
                    />
                  )}
                </div> */}
                <h2 className="video-heading">{currentVideo?.Title || ""}</h2>
                <p className="video-desc">{currentVideo?.Description || ""}</p>
              </div>
              <div className="videoSidebar">
                <div className="videoSidebar-inr">
                  <Nav variant="pills" className="video-ul">
                    {allVideos?.length > 0 &&
                      allVideos.map((val: IVideo) => {
                        return (
                          <Nav.Item
                            className="video-li"
                            key={val.Data.Id}
                            onClick={() => handleVideoSelect(val.Data)}>
                            <Nav.Link eventKey={val.Data.Id.toString()}>
                              <div className="video-otr">
                                <img className="video-img" src={VideoImg} alt="img" />
                              </div>
                              <p className="video-text">{val?.Data?.Title}</p>
                            </Nav.Link>
                          </Nav.Item>
                        );
                      })}
                  </Nav>
                </div>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

export default EducationalVideoMobile;
